import { create } from 'apisauce';

const createService = baseURL => {
   const api = create({ baseURL });

   const getMyMfaDetails = token => {
      api.setHeader('Authorization', `Bearer ${token}`);
      return api.get('/v1/contact/mfa/details');
   };

   const removeSmsEnrollment = token => {
      api.setHeader('Authorization', `Bearer ${token}`);
      return api.delete('/v1/contact/mfa/sms');
   };

   const removeAuthenticatorEnrollment = token => {
      api.setHeader('Authorization', `Bearer ${token}`);
      return api.delete('/v1/contact/mfa/authenticator');
   };

   const changeDefaultMfaMethod = (token, newMethod) => {
      api.setHeader('Authorization', `Bearer ${token}`);
      return api.patch(
         `/v1/contact/mfa/default-method?newMethod=${encodeURIComponent(
            newMethod
         )}`
      );
   };

   return {
      getMyMfaDetails,
      removeSmsEnrollment,
      removeAuthenticatorEnrollment,
      changeDefaultMfaMethod,
   };
};

export default { create: createService };
